module.exports = __webpack_public_path__ + "media/Video07_assertive.8cb974ff.mp4";